// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"ccb091e6","238":"731db1fe","455":"d70d2cfa","977":"35e1526d"}[chunkId] + ".chunk.js";
};